import { buildTrackingTag } from "../../utils/buildTrackingTag";
import { ITGMetadata } from "@ceeferenderer/itg-renderer-sdk/model/itgMetadata.model";
import { render } from "../../utils/render";
import type { LoginResponse } from "@dotcom/oauthjs";

export const handleRender = (htmlString: string, metaData: ITGMetadata, loginResponse: LoginResponse): void => {
  const html: Node = document.createRange().createContextualFragment(htmlString);
  html.appendChild(buildTrackingTag(metaData, loginResponse));
  render(
    html,
    Object.values(metaData)
      .map((value) => value.replace(/\s/g, "-"))
      .join(" ")
  );
};
